export default class Concept {
    constructor(uri, prefLabel, broader, narrower, definition, inScheme) {
        Object.defineProperty(this, "uri", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // A string that likely represents a unique identifier for the concept, often a URI in semantic web contexts.
        Object.defineProperty(this, "prefLabel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // A string for the preferred label, which is the primary name by which the concept is known.
        Object.defineProperty(this, "broader", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // An array of strings representing URIs of broader concepts, which this concept is a subset of.
        Object.defineProperty(this, "narrower", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // An array of strings for narrower concepts, indicating more specific concepts derived from this one.
        Object.defineProperty(this, "definition", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // A string providing the definition of the concept, explaining what it encompasses.
        Object.defineProperty(this, "inScheme", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        }); // URI of the ConceptScheme this concept belongs to.
        this.uri = uri;
        this.prefLabel = prefLabel;
        this.broader = broader;
        this.narrower = narrower;
        this.definition = definition;
        this.inScheme = inScheme;
    }
    toJSON() {
        return {
            uri: this.uri,
            prefLabel: this.prefLabel,
            broader: this.broader.map(broader => ({ href: broader })),
            narrower: this.narrower.map(narrower => ({ href: narrower })),
            definition: this.definition,
            ...(this.inScheme ? { inScheme: this.inScheme } : {}),
        };
    }
}
export { Concept };
